export default __webpack_public_path__ + "static/media/15_lanove-dopravni-zarizeni_PetraK_upr-min.a33a46f8.jpg";